import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93ccd04e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lang text-body-2" }
const _hoisted_2 = { for: "lang" }
const _hoisted_3 = { class: "select-holder" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('i18n.chooseLang')), 1),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
        id: "lang"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.lagnuages, (locale) => {
          return (_openBlock(), _createElementBlock("option", {
            key: locale.key,
            value: locale.key
          }, _toDisplayString(locale.title), 9, _hoisted_4))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.$i18n.locale]
      ]),
      _createElementVNode("input", {
        type: "text",
        value: $options.fakeSelectCapture,
        disabled: ""
      }, null, 8, _hoisted_5)
    ])
  ]))
}